/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-16 16:21:37
 */
import { CHANGE_STATUS, CHANGE_PAGE } from '../constant';

export const changeStatus = (payload: boolean) => ({
  type: CHANGE_STATUS,
  payload,
});

export const chagnePage = (payload: string) => ({
  type: CHANGE_PAGE,
  payload,
});
